module.exports = __webpack_public_path__ + "static/media/outer-circle.97f7d330.svg";